<template>
  <v-card>
    <v-form @keyup.native.enter.prevent="confirmCode" @submit="confirmCode" onSubmit="return false;">
      <v-toolbar dark color="light-blue darken-2" card>
        <v-toolbar-title>Код подтверждения</v-toolbar-title>
      </v-toolbar>
      
      <v-card-text>
        <v-alert
          v-model="showAlert"
          color="red"
          icon="warning"
          outline
          dismissible
          class="mb-5"
        >
          {{ errorMessage }}
        </v-alert>
        
        <v-text-field
          type="number"
          min="100001"
          max="999998"
          label="Введите код подтверждения"
          v-model="verification_code"
          :disabled="isLoading"
        />
        
        <span v-if="counter > 0">Выслать код повторно можно будет через {{ counter }} сек.</span>
        
        <a v-else @click.prevent="sendCodeAgain" v-show="!isLoading">Выслать код повторно</a>
      </v-card-text>
      
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn
          color="red"
          flat
          @click="$emit('cancel')"
          :disabled="isLoading"
        >Отменить</v-btn>
        
        <v-btn
          color="light-blue darken-2"
          @click="confirmCode"
          :disabled="!verification_code || isLoading"
          :loading="isLoading"
        >Подтвердить
        </v-btn>
      </v-card-actions>
    </v-form>
  </v-card>
</template>

<script>
  import { mapGetters } from 'vuex'
  import { isEmpty } from 'lodash'
  import apiAuth from "../api"
  import RegisterForm from './RegisterForm'
  import ResetForm from './ResetForm'
  
  export default {
    name: 'ConfirmCode',
    
    components: {
      RegisterForm,
      ResetForm,
    },
    
    props: {
      userName: {
        type: String,
        default: ''
      },
      context: {
        type: String,
        default: ''
      },
      forceSend: {
        type: Boolean,
        required: false,
        default: false,
      },
      resendDelay: {
        type: Number,
        default: 59
      }
    },
    
    data() {
      return {
        verification_code: '',
        
        counter: 0,
        timer: null,
        
        isLoading: false,
        
        errorMessage: ''
      }
    },
    
    computed:{
      showAlert: {
        get: function() {
          return !isEmpty(this.errorMessage)
        },
        set: function(newValue) {
          if (!newValue) this.errorMessage = ''
        }
      }
    },
    
    created(){
      if(this.forceSend) this.sendCodeAgain()
    },
    
    methods: {
      startTimer() {
        this.counter = this.resendDelay
        
        this.timer = setInterval(() => {
          if (this.counter > 0) {
            this.counter--
          } else {
            clearInterval(this.timer)
          }
        }, 1000)
      },
      
      clearTimer() {
        clearInterval(this.timer)
        this.counter = 0
      },
      
      sendCodeAgain() {
        this.isLoading = true
        
        apiAuth.resendCode({
          email_phone: this.userName,
          context: this.context
        }).then(response => {
          this.startTimer()
        }).catch(error => {
          // console.warn(error)
          this.errorMessage = error.response && error.response.data && error.response.data.error
            ? error.response.data.error
            : "Server connection error"
        }).finally(() => {
          this.isLoading = false
        })
      },
      
      confirmCode() {
        this.isLoading = true
        
        apiAuth.confirm({
          email_phone: this.userName,
          code: parseInt(this.verification_code)
        }).then(response => {
          this.$store.commit('app/account/setAuthTokens', response)
          if (localStorage) {
            localStorage.setItem("dms_auth_tokens", JSON.stringify(response))
          }
          this.$emit('confirm', this.verification_code)
        }).catch(error => {
          this.errorMessage = error.response && error.response.data && error.response.data.error
            ? error.response.data.error
            : "Server connection error"
        }).finally(() => {
          this.isLoading = false
        })
      }
    }
  }
</script>

<style scoped>
  .error--text{
    color: #f44336 !important;
    caret-color: #f44336 !important;
  }
</style>



// WEBPACK FOOTER //
// src/apps/auth/components/ConfirmCode.vue